import React from 'react'
import SearchNav from '../../SearchNav/SearchNav'

const Health = () => {
  return (
    <div>
        <SearchNav/>
        <h1 className='p-3'>Health</h1>
    </div>
  )
}

export default Health